import { render } from "./GameDescription.vue?vue&type=template&id=402cdb51&scoped=true"
import script from "./GameDescription.vue?vue&type=script&lang=js"
export * from "./GameDescription.vue?vue&type=script&lang=js"

import "./GameDescription.vue?vue&type=style&index=0&id=402cdb51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402cdb51"]])

export default __exports__